namespace Matrix.Visualizer {
    export interface GraphDataRequest extends Serenity.ServiceRequest {
        GraphInstanceId?: number;
        GraphKey?: string;
        InstanceKey?: string;
        ThemeKey?: string;
    }
}
